module.exports = __webpack_public_path__ + "assets/img/example2.33fa89d9.jpg";